"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { useState } from "react";
import { useTranslations } from "use-intl";
import { NETWORK_ONLY_OPERATION_CONTEXT } from "../../../constants";
import { useAddress } from "../../../polychain/hooks/useAddress";
import { FlowActions } from "../../../stores/flowStore";
import { useEndFlowOnAccountChange } from "../../hooks/useEndFlowOnAccountChange";
import { TransferFlowDone } from "./components/TransferFlowDone";
import { TransferFlowDone_itemFragment } from "./components/TransferFlowDone/TransferFlowDone.fragment";
import { TransferFlowForm, TransferFlowFormSkeleton } from "./components/TransferFlowForm";
import { TransferFlowForm_itemFragment } from "./components/TransferFlowForm/TransferFlowForm.fragment";
import { TransferFlowReview } from "./components/TransferFlowReview";
import { TransferFlowReview_itemFragment } from "./components/TransferFlowReview/TransferFlowReview.fragment";
const TransferFlowQuery = graphql(`
    query TransferFlowQuery(
      $identifiers: [ItemIdentifierInput!]!
      $address: Address
    ) {
      itemsByIdentifiers(identifiers: $identifiers) {
        ...TransferFlowForm_item
        ...TransferFlowDone_item
        ...TransferFlowReview_item
      }
    }
  `, [TransferFlowForm_itemFragment, TransferFlowDone_itemFragment, TransferFlowReview_itemFragment]);
export function TransferFlow(t0) {
  const $ = _c(31);
  const {
    items: itemsInput
  } = t0;
  const t = useTranslations("wallet.TransferFlow");
  const [formValues, setFormValues] = useState();
  const address = useAddress();
  let t1;
  if ($[0] !== itemsInput) {
    t1 = itemsInput.map(_temp);
    $[0] = itemsInput;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== address || $[3] !== t1) {
    t2 = {
      query: TransferFlowQuery,
      variables: {
        identifiers: t1,
        address
      },
      context: NETWORK_ONLY_OPERATION_CONTEXT
    };
    $[2] = address;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [t3] = useQuery(t2);
  const {
    data,
    fetching
  } = t3;
  useEndFlowOnAccountChange();
  const [view, setView] = useState("create");
  let t4;
  if ($[5] !== data?.itemsByIdentifiers) {
    t4 = data?.itemsByIdentifiers.flatMap(_temp2);
    $[5] = data?.itemsByIdentifiers;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const items = t4;
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = values => {
      setFormValues(values);
      setView("review");
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleFormSubmit = t5;
  if (fetching) {
    let t6;
    if ($[8] !== itemsInput.length) {
      t6 = <TransferFlowFormSkeleton count={itemsInput.length} />;
      $[8] = itemsInput.length;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  if (!items) {
    throw new Error(t("errorMessage"));
  }
  let t6;
  if ($[10] !== formValues || $[11] !== items || $[12] !== view) {
    t6 = view === "create" && <TransferFlowForm defaultValues={formValues} items={items} onSubmit={handleFormSubmit} />;
    $[10] = formValues;
    $[11] = items;
    $[12] = view;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== formValues || $[15] !== items || $[16] !== view) {
    t7 = view === "review" && formValues && <TransferFlowReview formValues={formValues} items={items} onBack={() => setView("create")} onError={() => setView("error")} onSuccess={() => {
      setView("success");
      FlowActions.onSuccess();
    }} />;
    $[14] = formValues;
    $[15] = items;
    $[16] = view;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== items || $[19] !== t || $[20] !== view) {
    t8 = view === "success" && <TransferFlowDone items={items} title={t("successTitle")} withLink={true} />;
    $[18] = items;
    $[19] = t;
    $[20] = view;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== items || $[23] !== t || $[24] !== view) {
    t9 = view === "error" && <TransferFlowDone body={t("errorBody")} items={items} title={t("errorTitle")} withError={true} />;
    $[22] = items;
    $[23] = t;
    $[24] = view;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t6 || $[27] !== t7 || $[28] !== t8 || $[29] !== t9) {
    t10 = <>{t6}{t7}{t8}{t9}</>;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  return t10;
}
function _temp2(item_0) {
  return item_0 ? [item_0] : [];
}
function _temp(item) {
  return {
    tokenId: item.tokenId,
    contractAddress: item.contractAddress,
    chain: item.chain.identifier
  };
}